import React from "react";

import RadioOptionGroup from "Components/radioOptionGroup";

import {
  PREFERRED_START_OPTIONS,
  PREFERRED_START_EXTRA_TIME_OPTION,
} from "Constants";

const PreferredStart = (props) => {
  const { value, onChange, disabled, extraTimeOption } = props;

  const options = extraTimeOption
    ? [PREFERRED_START_EXTRA_TIME_OPTION]
    : PREFERRED_START_OPTIONS;

  return (
    <RadioOptionGroup
      onChange={onChange}
      value={value}
      className="flex-actions--collumn flex-actions--min-height"
      radioOptions={options}
      disabled={disabled}
    />
  );
};

export default PreferredStart;
